export default "__VITE_ASSET__DVSzqgj4__"